import { CommonService } from './../../../shared/services/common.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { AuthfakeauthenticationService } from 'src/app/core/services/authfake.service';
import { EventService } from 'src/app/core/services/event.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-workspace-mobile',
  templateUrl: './workspace-mobile.component.html',
  styleUrls: ['./workspace-mobile.component.scss']
})
export class WorkspaceMobileComponent implements OnInit {


  loginForm: FormGroup;
  submitted = false;
  error = '';
  returnUrl: string;
  id = JSON.parse(localStorage.getItem('currentUser')).id
  userToken = JSON.parse(localStorage.getItem('currentUser')).user_token
  // set the currenr year
  year: number = new Date().getFullYear();
  isChecked: boolean = false;
  @ViewChild('usernameInput') usernameInput: ElementRef | undefined;
  @ViewChild('passwordInput') passwordInput: ElementRef | undefined;
  tableName: string = 'workspaces';
  fullName = <any>[];
  idWs: number;
  pageSize = 10
  pageIndex = 1
  totalCount = 0
  data = <any>{};
  listData = <any>[];
  // tslint:disable-next-line: max-line-length
  constructor(
    private commonService: CommonService,
    private authService: AuthenticationService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private apiService: ApiService,
    private translateService: TranslateService,
    public authenticationService: AuthenticationService,
    public authFackservice: AuthfakeauthenticationService,

  ) {
  }
  flagWorkSpace = this.commonService.flagWorkSpace
  ngOnInit() {
    this.fetchData();
    this.fetchDataAccount()
    document.body.removeAttribute('data-layout');
    document.body.classList.add('auth-body-bg');
    document.querySelector('.modal-backdrop')?.remove();
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
  }


  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }
  onCheckboxChange(event: Event) {
    this.isChecked = (event.target as HTMLInputElement).checked;
    localStorage.setItem('rememberMe', JSON.stringify(this.isChecked));

    if (this.isChecked) {
      const username = this.f.username.value;
      const password = this.f.password.value;
      localStorage.setItem('credentials', JSON.stringify({ username, password }));
    } else {
      localStorage.removeItem('credentials');
    }
  }
  filter = {
    name: ''
  }
  searching = false

  params = ''
  submitFilter() {
    this.params = ''
    Object.keys(this.filter).forEach(key => {
      console.log(key + '-' + this.filter[key])
      if (this.filter[key]) {
        this.params += `&${key}=${this.filter[key]}`
      }
    })

    if (this.params) {
      this.pageIndex = 1
      this.searching = true
      this.fetchData()
    }
  }
  selected: any;

  clearFilter() {
    this.selected = ''
    this.params = ''
    this.filter.name = ''
    this.pageIndex = 1
    this.searching = false
    this.fetchData()
  }
  fetchData() {
    this.eventService.setLoading(true)
    this.apiService.getList(this.tableName
    ).subscribe({
      next: (res) => {
        this.listData = res['workspaces'] ? res['workspaces'] : [];
        if (this.listData.length < 0) {
          this.router.navigate(['/account/landing-page']);
        }
        this.eventService.setLoading(false)
      }
    })
  }

  // form
  formData: FormGroup
  get form() {
    return this.formData.controls
  }
  listBankname = [
    {
      name: 'MB Bank',
      id: '970422'
    }
  ]
  binNumber = '970422'
  accountNumber = ''
  bank_accountName = ''
  name: ''
  terminalAddress: ''
  dataUser
  fetchDataAccount() {
    this.apiService.getList('account-list'
    ).subscribe({
      next: (res) => {
        this.dataUser = res['metadata']['accountList'] ? res['metadata']['accountList'] : [];
        
      }
    })

  }
  onInputBlur() {
    this.eventService.setLoading(true);

    const data = {
      partner_id: this.id,
      accountNumber: this.accountNumber,
      token: this.userToken
    };

    this.apiService.apiPostToPaydee('prod/bank/account-info',data)
      .subscribe(
        (response: any) => {
          if (response.ResponseData.errorCode === '200' && !response.ResponseData.data) {
            this.apiService.showToastMobile(
              'error',
              this.translateService.instant('Không tìm thấy tài khoản')
            );
          } else if (response.ResponseData.data) {
            this.apiService.showToastMobile(
              this.translateService.instant('success'),
              this.translateService.instant('Tìm kiếm thành công')
            );
            this.bank_accountName = response.ResponseData.data.accountName;
            this.searching = true;
          } else {
            this.apiService.showToastMobile(
              'error',
              this.translateService.instant('Có lỗi xảy ra khi tìm kiếm tài khoản')
            );
          }

          this.eventService.setLoading(false);
        },
        (error) => {
          console.error('Error occurred:', error);
          this.apiService.showToastMobile(
            'error',
            this.translateService.instant('Lỗi kết nối. Vui lòng thử lại sau.')
          );
          this.eventService.setLoading(false);
        }
      );
  }

  //backToApp
  onBack() {
    Swal.fire({
      // title: this.translateService.instant('FORM.Warning'),
      text: this.translateService.instant('Bạn có chắc chắn muốn đóng ứng dụng?'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#141ED2',
      cancelButtonColor: 'fff',
      confirmButtonText: this.translateService.instant('FORM.WarningConfirm'),
      cancelButtonText: this.translateService.instant('FORM.Cancel'),
      customClass: {
        icon: 'my-custom-icon-class'
      }
    }).then(result => {
      if (result.value) {
        this.authFackservice.logoutMobile();

        setTimeout(() => {
          if (window['ReactNativeWebView']) {
            window['ReactNativeWebView'].postMessage(JSON.stringify({
              type: 'GO_BACK',
            }));
            console.log('Message posted to React Native WebView');
          } else {
            console.warn('ReactNativeWebView không tồn tại. Sử dụng môi trường local để test.');
            window['ReactNativeWebView'] = {
              postMessage: (message) => {
                console.log('Message posted to React Native (mock):', message);
              }
            };
            window['ReactNativeWebView'].postMessage(JSON.stringify({
              type: 'GO_BACK',
            }));
          }
        }, 2000);
      }
    });

  }



  resetShop() {

  }
  saveData() {
    const data = {
      name: this.name,
      terminalAddress: this.terminalAddress,
      terminalBankAcc: this.accountNumber,
      terminalBankName: this.binNumber,
      terminalBankAccountName: this.bank_accountName
    }
    this.apiService.addItem(this.tableName + "-v2", data).subscribe({
      next: res => {
        this.flagWorkSpace = true;
        localStorage.setItem('workspace', res['metadata']?.workspaceId);
        this.router.navigate(['/account/landing-page'], { queryParams: { section: 1 } });
        // this.apiService.showToastMobile(this.translateService.instant('success'), this.translateService.instant('Thêm mới thành công'))
        this.eventService.setLoading(false)
        document.querySelector('.modal-backdrop')?.remove();
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';

      },
      error: e => {
        this.apiService.showToastMobile('error', this.translateService.instant('FORM.ErrorMessageAdd'))
        this.eventService.setLoading(false)
      }
    })
  }
  /**
   * Form submit
   */
  showId(index: any) {
    localStorage.setItem('workspace', index.id);
    localStorage.setItem('workSpace1', index.name);
    localStorage.setItem('workSpaceCode', index.code);
    this.router.navigate(['/viettel/dashboard']);
  }
  toDevice(index: any) {
    localStorage.setItem('workspace', index.id);
    localStorage.setItem('workSpace1', index.name);
    localStorage.setItem('workSpaceCode', index.code);
    this.router.navigate(['/viettel/create-device']);
  }
  toOrders(index: any) {
    localStorage.setItem('workspace', index.id);
    localStorage.setItem('workSpace1', index.name);
    localStorage.setItem('workSpaceCode', index.code);
    this.router.navigate(['/viettel/orders']);
  }
  logout() {
    if (environment.defaultauth === 'firebase') {
      this.authService.logout();
    } else {
      this.authFackservice.logout();
      this.router.navigate(['/account/login-mobile']);
      localStorage.removeItem('workspace');
      localStorage.removeItem('workSpaceCode');
      localStorage.removeItem('workSpace1');
      }
  }
}
